import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Spinner from './Spinner';

import './Loading.scss';

export default function FullPageLoader({ isLoading = false }) {
  // Prevent scrolling when the loader is active
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden"; // Disable scroll
    } else {
      document.body.style.overflow = "auto"; // Enable scroll
    }

    return () => {
      document.body.style.overflow = "auto"; // Clean up when unmounting
    };
  }, [isLoading]);

  if(!isLoading) return ;

  return (
    <div className='fullPageLoader'><Spinner /></div>
  );
};

FullPageLoader.propTypes = {
  isLoading: PropTypes.bool,
};